/**
 * Created by Jason on 2017-4-14.
 */
/**
 * options
 * el: 生效的元素
 * pageSize: 默认一页的条数
 * getData(size, pageNo, setHTML, errorCallBack)，参数 获取条数，页码，设置HTML函数，渲染错误callback
 */
class Paging {
    constructor(options) {
        let _this = this;
        _this.$el = $(options.el).eq(0).addClass('paging');
        _this.getData = options.getData;
        _this.pageSize = options.pageSize;
        _this.init();
        _this._event();
    }
    /**
     * 初始化
     */
    init(handler) {
        this.empty();
        this._next(handler);
    }
    /**
     * 清空数据
     */
    empty() {
        let _this = this;
        _this.cb = null;
        _this.isEnd = false;
        _this.page = 0;
        _this.size = 0;
        _this.$el.removeClass('paging-loading paging-end');
        _this.$el.html('');
    }
    /**
     * 绑定事件
     * @private
     */
    _event() {
        let _this = this;
        _this.$el.on('scroll', _this._scroll.bind(_this));
        $(window).on('resize', function () {
            setTimeout(_this._scroll.bind(_this), 10);
        });
    }

    /**
     * 滚动函数
     * @private
     */
    _scroll() {
        let _this = this;
        if (_this.cb) {
            return;
        }
        if (_this.isEnd) {
            return;
        }
        let scrollTop = _this.$el.scrollTop();
        let height = _this.$el.innerHeight();
        let scrollHeight = _this.$el.prop('scrollHeight');
        if (scrollHeight - scrollTop - height < 1) {
            _this.$el.addClass('paging-loading');
            _this._next()
        }
    }
    /**
     * 重新加载
     */
    refresh(handler) {
        let _this = this;
        _this._getData(1, (_this.page || 1) * _this.pageSize, handler, true);
    }
    /**
     * 下一页
     * @private
     */
    _next(handler) {
        let _this = this;
        _this._getData(_this.page + 1, _this.pageSize, handler, false);
    }

    /**
     * 获取数据
     * @param page
     * @param size
     * @param handler
     * @param isRefresh
     * @private
     */
    _getData(page, size, handler, isRefresh) {
        let _this = this;
        let cb = _this.cb = (html) => {
            if (cb !== _this.cb) {
                if (handler) {
                    handler(false);
                }
                //上一次请求尚未返回，
                // 如有新请求，上一次作废。
                return;
            }
            _this.cb = null;
            _this._html(html, isRefresh);
            if (handler) {
                handler(true);
            }
        };
        _this.getData(page, size, cb, () => {
            //请求调用错误
            if (handler) {
                handler(false);
            }
            if (cb === _this.cb) {
                _this.cb = null;
            }
            _this.$el.removeClass('paging-loading');
        }, isRefresh);
    }

    /**
     * html
     * @param html
     * @param isRefresh
     * @private
     */
    _html(html, isRefresh) {
        let _this = this;
        let $el = _this.$el;
        $el.removeClass('paging-loading');
        if (!html) {
            _this._end();
        } else {
            _this.$el.removeClass('paging-end');
        }
        if (isRefresh) {
            $el.html(html);
        } else {
            if (!html) {
                return;
            }
            _this.page ++;
            $el.append(html);
        }
        _this.size = $el.children().length;
        if (_this.size % _this.pageSize) {
            _this._end();
            return;
        } else {
            _this.$el.removeClass('paging-end');
        }
        if (!isRefresh) {
            //判断还有下一页数据的情况下，模拟一次滚动，防止首次加载完毕，出现没有滚动条的情况。
            _this._scroll();
        }
    }
    /**
     * 到底了
     * @private
     */
    _end() {
        let _this = this;
        _this.isEnd = true;
        _this.$el.addClass('paging-end');
    }
}

module.exports = Paging;


// WEBPACK FOOTER //
// ./src/assets/lib/paging/paging.js